export default "/build/dist/c9e65adb8da099ac.wasm"